module.exports = __webpack_public_path__ + "media/service_features/o_s-9f1b5d56.png";